import { CAL_GPU_CARD_MNG } from '@/api/apiModules'
export default {
  viewType: 'table',
  module: CAL_GPU_CARD_MNG,
  sortArr: [
    {
      fieldName: 'createTime',
      direction: 'DESC'
    }
  ],
  refreshInterval: false,
  // relationSearch: true,
  allowStatus: {},
  toolbar: {
    searchPlaceholder: '请输入显卡名称',
    moreBtnWidth: 160,
    searchFieldNameArr: ['name'],
    hasColAdjustment: true,
    items: [
      {
        slot: 'refresh-rigtht',
        label: 'create',
        props: {
          type: 'primary',
          icon: 'el-icon-plus'
        },
        action: 'gpuCardCreate'
      }
    ]
  },

  view: {
    columns: [
      {
        props: {
          label: '显卡名称',
          prop: 'name',
          sortField: 'name',
          width: 180
        }
      },
      {
        props: {
          label: '服务器支持最大显卡张数(与具体服务器相关)',
          prop: 'serverMaxSupport',
          sortField: 'serverMaxSupport',
          width: 320
        }
      },
      {
        props: {
          label: '显卡切分数据（GB）',
          prop: 'dividedContent',
          sortField: 'dividedContent',
          width: 450
        }
      },
      {
        props: {
          label: '显存大小（GB）',
          prop: 'capacity',
          sortField: 'capacity'
        }
      },
      {
        props: {
          label: '创建时间',
          prop: 'createTime',
          sortField: 'createTime',
          width: 350
        },
        dataType: 'date'
      }
    ]
  }
}
